import { makeAutoObservable } from 'mobx'
import { axiosInstance } from '../hooks/useAxios'
import { getPublicConfig } from '../api/getPublicConfig'
import { getConfig } from '../api/getConfig'
import { NavigationItem } from '../components/Navigation'
import { PublicConfig, Vendor } from '../server/public/config/get'

export interface PrivateConfig {
  navigation: NavigationItem[]
  socialsVendors: Vendor[]
}

class _ConfigStore {
  publicConfig: PublicConfig = {
    authorizationVendors: []
  }
  privateConfig: PrivateConfig = {
    socialsVendors: [],
    navigation: []
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  setPublicConfig = (data: PublicConfig): void => {
    this.publicConfig = data
  }

  setPrivateConfig = (data: PrivateConfig): void => {
    this.privateConfig = data
  }

  async getConfig(type: 'public' | 'private') {
    try {
      if (type === 'public') {
        const res = await axiosInstance(getPublicConfig())

        this.setPublicConfig(res?.data?.data ?? {})
      } else {
        const res = await axiosInstance(getConfig())

        this.setPrivateConfig(res?.data?.data ?? {})
      }
    } catch (e) {
      console.error(e)
    }
  }
}

const ConfigStore = new _ConfigStore()

export { ConfigStore }
